import { formatNumberCoords } from '../utils/functions';
const rochdale = [
  53.683378299014215,
  -2.0522323704666023,
  53.67727790154661,
  -2.083474741072071,
  53.67097322921472,
  -2.0851913548416023,
  53.66975286106967,
  -2.0920578099197273,
  53.67219356201296,
  -2.0961776829666023,
  53.67097322921472,
  -2.1195236302322273,
  53.67341385946481,
  -2.1253601170486336,
  53.685614890037215,
  -2.13119660386504,
  53.68215829020666,
  -2.148019418806446,
  53.65429180490218,
  -2.164498910993946,
  53.64818719503279,
  -2.159005746931446,
  53.64269229042609,
  -2.1596923924392586,
  53.63963925626739,
  -2.1789184666580086,
  53.64879769579381,
  -2.1813217259353523,
  53.65185006701745,
  -2.205697641462696,
  53.66975286106967,
  -2.2197738743728523,
  53.67117662046906,
  -2.2293869114822273,
  53.64520960048912,
  -2.2681823826736336,
  53.622002383068704,
  -2.26028595933379,
  53.61915149376494,
  -2.2609726048416023,
  53.615282121723354,
  -2.2709289647048836,
  53.60669977303003,
  -2.26028595933379,
  53.607310874284224,
  -2.251016244978321,
  53.60160691868318,
  -2.24380646714629,
  53.59162314268564,
  -2.269898996443165,
  53.58102553451565,
  -2.2719589329666023,
  53.58122935973359,
  -2.2668090916580086,
  53.58591706849366,
  -2.264749155134571,
  53.58612087012465,
  -2.2582260228103523,
  53.57124076822705,
  -2.24380646714629,
  53.5632889781084,
  -2.245179758161915,
  53.56063804915387,
  -2.2348800755447273,
  53.55839482566333,
  -2.2407165623611336,
  53.540240733492766,
  -2.2365966893142586,
  53.54350496468347,
  -2.2173706150955086,
  53.533915569258774,
  -2.206727609724415,
  53.52942616976104,
  -2.1854415989822273,
  53.55084856459061,
  -2.1706787205642586,
  53.55819089035684,
  -2.1706787205642586,
  53.56532804118182,
  -2.149392709822071,
  53.57511417566358,
  -2.150766000837696,
  53.576948823763786,
  -2.1583191014236336,
  53.58082170831499,
  -2.135659799665821,
  53.59182691680022,
  -2.1195236302322273,
  53.59242815024481,
  -2.110921861015458,
  53.5985408297544,
  -2.1116085065232704,
  53.59202060683197,
  -2.063199998222489,
  53.59283568972688,
  -2.0515270245896766,
  53.59813334530134,
  -2.0515270245896766,
  53.601800563881824,
  -2.036764146171708,
  53.61055985295379,
  -2.0309276593553016,
  53.61565162774267,
  -2.0323009503709266,
  53.62542611411988,
  -2.025777818046708,
  53.629150453202755,
  -2.030241013847489,
  53.63627562710127,
  -2.0268077863084266,
  53.64095722908344,
  -2.0374507916795204,
  53.65805084000823,
  -2.034360886894364,
  53.66374717048539,
  -2.037107468925614,
  53.66984952742992,
  -2.051870347343583,
  53.6749341498466,
  -2.054960252128739,
  53.67900140596205,
  -2.0484371198045204,
];

export const rochdaleAreaCoords = formatNumberCoords(rochdale);
